// importing icons
import homeIcon from "./icons/home.svg";
import inventoryIcon from "./icons/inventory.svg";
import reportsIcon from "./icons/reports.svg";
import enrollmentIcon from "./icons/enrollment.svg";
import settingsIcon from "./icons/settings.svg";
import toolsIcon from "./icons/tools.svg";
import devices from "./icons/devices.svg"
import alertIcon from "./icons/bell-svgrepo-com.svg"
import patchIcon from "./icons/patch.svg";
import { IS_MSP } from "common-ui-components/components/utils/Config";
import {ALL_CUSTOMER_ID} from "../../utils/mspConstants";

const pathPrefix = "/app";

export const getNavigationList = (currentModule, currentCustomerId = 1) => {
    const IS_MSP_AND_IS_ALL_CUSTOMER = IS_MSP && Number(currentCustomerId) === ALL_CUSTOMER_ID;

    return [
        {
            name: "Home",
            path:
                IS_MSP_AND_IS_ALL_CUSTOMER && currentModule !== "HOME"
                    ? pathPrefix + "/home-customer-summary"
                    : pathPrefix + "/home",
            icon: homeIcon,
            key: "HOME",
            products: ["em", "em-msp", "am", "vm", "pm"],
        },
        {
            name: "Inventory",
            path:
                IS_MSP_AND_IS_ALL_CUSTOMER && currentModule !== "INVENTORY"
                    ? pathPrefix + "/inventory-customer-summary"
                    : pathPrefix + "/inventory",
            icon: inventoryIcon,
            key: "INVENTORY",
            products: ["em", "am"],
        },
        {
            name: "Manage",
            path: pathPrefix + "/manage",
            icon: devices,
            key: "MANAGE",
            products: ["em"],
        },
        {
            name: "Secure",
            path:
                IS_MSP_AND_IS_ALL_CUSTOMER && currentModule !== "PATCH"
                    ? pathPrefix + "/patches-customer-summary"
                    : pathPrefix + "/secure",
            icon: patchIcon,
            key: "PATCH",
        },
        {
            name: "Remote",
            path: pathPrefix + "/tools",
            icon: toolsIcon,
            key: "REMOTE",
            products: ["em", "ra"],
        },
        {
            name: "Alerts",
            path: pathPrefix + "/alerts",
            icon: alertIcon,
            key: "ALERTS",
            products: ["em", "am"],
        },
        {
            name: "Reports",
            path: pathPrefix + "/reports",
            icon: reportsIcon,
            key: "REPORTS",
            products: ["em", "am"],
        },
        {
            name: "Enrollment",
            path: pathPrefix + "/enrollment",
            icon: enrollmentIcon,
            key: "ENROLLMENT",
            products: ["em", "am", "ra"],
        },
        {
            name: "Settings",
            path: pathPrefix + "/settings",
            icon: settingsIcon,
            key: "SETTINGS",
            products: ["em", "am", "ra"],
        },
    ];
};
